module.exports = __webpack_public_path__ + "img/bay.0d68bc85.svg";